import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorStore, Translation } from '@sleipai/sleip-models';

export const TranslationsActions = createActionGroup({
  source: 'Translations',
  events: {
    loadInitalTranslations : emptyProps(),
    loadTranslationbyType: (translationType: string) => ({ translationType }),
    translationLoadedSuccess: props<{ translation: Translation }>(),
    translationLoadedFailure: props<{ error: ErrorStore | string | null | any }>(),
  },
});
